import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export default mutatorAction(
    'toggleMaximize',
    (windowId: string = 'default', isMaximized: boolean) => {
        getStore().maximized.set(windowId, isMaximized);
    }
);
